
/* eslint-disable */
import { v4 as uuidv4 } from 'uuid';

function arrayMin(arr) {
    var len = arr.length, min = Infinity;
    while (len--) {
        if (arr[len] < min) {
        min = arr[len];
        }
    }
    return min;
}

function arrayMove(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing purposes
};
  

export default {
    setActiveWorkout(state, workoutId){
        state.activeWorkout = workoutId
    },
    setOpened(state, opened) {
        state.opened = opened
    },
    addItemToCircuit(state, payload) {
        state.circuits.push(payload)
    },
    addEmptyCircuit(state) {
        state.circuits.push({
            type: '',
            id: uuidv4(),
            work: '',
            rest: '',
            confirmed: false,
            items: [],
            moves: [],
        })
    },
    moveItemsUp(state) {
        for (let k=0;k<state.selectedMoves.length;k++) {
            const moveId = state.selectedMoves[k]
            let circuitIndex
            let moveIndex
            // discover which circuit to pop
            for(let i=0;i<state.circuits.length;i++) {
                const circuit = state.circuits[i]
                for (let j=0;j<circuit.items.length;j++){
                    if (!circuit.items[j]){
                        continue
                    }
                    if (moveId === circuit.items[j].id){
                        circuitIndex = i
                        moveIndex = j
                        break
                    }
                }
            }
            state.circuits[circuitIndex].items = arrayMove(state.circuits[circuitIndex].items, moveIndex, moveIndex-1)
        }
    },
    moveItemsDown(state) {
        for (let k=0;k<state.selectedMoves.length;k++) {
            const moveId = state.selectedMoves[k]
            let circuitIndex
            let moveIndex
            // discover which circuit to pop
            for(let i=0;i<state.circuits.length;i++) {
                const circuit = state.circuits[i]
                for (let j=0;j<circuit.items.length;j++){
                    if (!circuit.items[j]){
                        continue
                    }
                    if (moveId === circuit.items[j].id){
                        circuitIndex = i
                        moveIndex = j
                        break
                    }
                }
            }
            if (moveIndex+1 === state.circuits[circuitIndex].items.length){
                continue
            }
            state.circuits[circuitIndex].items = arrayMove(state.circuits[circuitIndex].items, moveIndex, moveIndex+1)
        }
    },
    moveItemsFirst(state) {
        for (let k=0;k<state.selectedMoves.length;k++) {
            const moveId = state.selectedMoves[k]
            let circuitIndex
            let moveIndex
            // discover which circuit to pop
            for(let i=0;i<state.circuits.length;i++) {
                const circuit = state.circuits[i]
                for (let j=0;j<circuit.items.length;j++){
                    if (!circuit.items[j]){
                        continue
                    }
                    if (moveId === circuit.items[j].id){
                        circuitIndex = i
                        moveIndex = j
                        break
                    }
                }
            }
            state.circuits[circuitIndex].items = arrayMove(state.circuits[circuitIndex].items, moveIndex, 0)
        }
    },
    moveItemsLast(state) {
        for (let k=0;k<state.selectedMoves.length;k++) {
            const moveId = state.selectedMoves[k]
            let circuitIndex
            let moveIndex
            // discover which circuit to pop
            for(let i=0;i<state.circuits.length;i++) {
                const circuit = state.circuits[i]
                for (let j=0;j<circuit.items.length;j++){
                    if (!circuit.items[j]){
                        continue
                    }
                    if (moveId === circuit.items[j].id){
                        circuitIndex = i
                        moveIndex = j
                        break
                    }
                }
            }
            state.circuits[circuitIndex].items = arrayMove(state.circuits[circuitIndex].items, moveIndex, state.circuits[circuitIndex].items.length-1)
        }
    },    
    addEmptyMoveToCurrentCircuit(state) {
        if (state.circuits.length > 0) {
            const id = uuidv4()
            const newItem = {
                name: '',
                notes: '',
                confirmed: false,
                id,
                type: 'move'
            }
            state.circuits[state.circuits.length - 1].items.push(newItem)
            state.circuits[state.circuits.length - 1].moves.push(newItem)
            console.log(state.circuits[state.circuits.length - 1])
            setTimeout(()=>{
                try{
                    window.document.getElementById('move-'+id).focus()
                    window.document.getElementsByClassName('modal-body')[0].scrollTop = window.document.getElementsByClassName('modal-body')[0].scrollHeight    
                }
                catch(e){

                }
            }, 100)
        }
    },
    addEmptyMoveAboveToCurrentCircuit(state) {
        const moveId = state.selectedMoves[0]

        let circuitIndex
        let moveIndex
        // discover which circuit to pop
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                if (moveId === circuit.items[j].id){
                    circuitIndex = i
                    moveIndex = j
                    break
                }
            }
        }
        const newItem = {
            name: '',
            notes: '',
            confirmed: false,
            id: uuidv4(),
            type: 'move'
        }

        const newPosition = moveIndex

        state.circuits[circuitIndex].items.splice(newPosition, 0, newItem)
        state.circuits[circuitIndex].moves.splice(newPosition, 0, newItem)
    },

    addEmptyMoveBelowToCurrentCircuit(state) {
        const moveId = state.selectedMoves[0]

        let circuitIndex
        let moveIndex
        // discover which circuit to pop
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                if (moveId === circuit.items[j].id){
                    circuitIndex = i
                    moveIndex = j
                    break
                }
            }
        }
        const newItem = {
            name: '',
            notes: '',
            confirmed: false,
            id: uuidv4(),
            type: 'move'
        }

        const newPosition = moveIndex + 1

        state.circuits[circuitIndex].items.splice(newPosition, 0, newItem)
        state.circuits[circuitIndex].moves.splice(newPosition, 0, newItem)
    },

    addEmptyInstructionAboveToCurrentCircuit(state) {
        const moveId = state.selectedMoves[0]

        let circuitIndex
        let moveIndex
        // discover which circuit to pop
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                if (moveId === circuit.items[j].id){
                    circuitIndex = i
                    moveIndex = j
                    break
                }
            }
        }
        const newItem = {
            instruction: '',
            confirmed: false,
            id: uuidv4(),
            type: 'instruction'
        }

        const newPosition = moveIndex

        state.circuits[circuitIndex].items.splice(newPosition, 0, newItem)
    },

    addEmptyInstructionBelowToCurrentCircuit(state) {
        const moveId = state.selectedMoves[0]

        let circuitIndex
        let moveIndex
        // discover which circuit to pop
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                if (moveId === circuit.items[j].id){
                    circuitIndex = i
                    moveIndex = j
                    break
                }
            }
        }
        const newItem = {
            instruction: '',
            confirmed: false,
            id: uuidv4(),
            type: 'instruction'
        }

        const newPosition = moveIndex + 1

        state.circuits[circuitIndex].items.splice(newPosition, 0, newItem)
    },

    addEmptyInstructionToCurrentCircuit(state) {
        if (state.circuits.length > 0) {
            state.circuits[state.circuits.length - 1].items.push({
                instruction: '',
                confirmed: false,
                id: uuidv4(),
                type: 'instruction'
            })
        }
    },
    setCircuit(state, payload){
        state.circuits = payload
    },
    removeCircuit(state, id) {
        state.circuits = state.circuits.filter(circuit => circuit.id !== id)
    },
    updateCircuit(state, updateCircuit) {
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            if (circuit.id === updateCircuit.id) {
                Object.assign(state.circuits[i], updateCircuit)
                break
            }
        }
    },
    updateCircuitId(state, {circuitId, dbId}) {
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            if (circuit.id === circuitId) {
                state.circuits[i].id === dbId
                break
            }
        }
    },
    updateCircuitList(state, {circuitId, items}) {
        for(let i=0;i<state.circuits.length;i++) {
            const currentCircuit = state.circuits[i]
            if (currentCircuit.id === circuitId) {
                Object.assign(state.circuits[i], {items})
                break
            }
        }
    },
    updateItem(state, updateItem){
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                const item = circuit.items[j]
                if (item.id === updateItem.id) {
                    Object.assign(state.circuits[i].items[j], updateItem)
                    break
                }
            }
        }
    },
    removeItem(state, id){
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            state.circuits[i].items = circuit.items.filter(item => item.id !== id)
        }
        state.circuits =  JSON.parse(JSON.stringify(state.circuits))
    },
    removeMove(state, id){
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            state.circuits[i].moves = circuit.moves.filter(item => item.id !== id)
        }
        state.circuits =  JSON.parse(JSON.stringify(state.circuits))
    },
    
    updateMove(state, updateMove){
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.moves.length;j++){
                const item = circuit.moves[j]
                if (item.id === updateMove.id) {
                    Object.assign(state.circuits[i].moves[j], updateMove)
                    break
                }
            }
        }
    },

    pushSelectedMoves(state, moveId) {
        if (state.selectedMoves.length === 0){
            state.selectedMoves.push(moveId)
            return
        }
        // look for circuit of the move id to push
        let currentCircuit = state.circuits.find(circuit => {
            return circuit.items.map(item => parseInt(item.id)).includes(moveId)
        })

        // look for the circuit of 1 of the moves since they are homogenous
        let activeCircuit = state.circuits.find(circuit => {
            return circuit.items.map(item => parseInt(item.id)).includes(state.selectedMoves[0])
        })
        
        // if pending move' circuit === selected moves' circuit then add it
        if (currentCircuit.id !== activeCircuit.id){
            state.selectedMoves = []
        }
        
        state.selectedMoves.push(moveId)
    },

    popSelectedMoves(state, moveId) {
        state.selectedMoves = state.selectedMoves.filter(move => move != moveId)
    },

    clearSelectedMoves(state) {
        state.selectedMoves = []
    },

    createRound(state) {
        const selectedMoves = state.selectedMoves
        let circuitIndex
        // discover which circuit to pop
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                if (selectedMoves.includes(circuit.items[j].id)){
                    circuitIndex = i
                    break
                }
            }
        }
        // learn the indexes of selectedMoves
        const selectedIndexes = []
        const selectedMoveObjects = []
        const activeCircuit = state.circuits[circuitIndex]
        for (let j=0;j<activeCircuit.items.length;j++){
            if (selectedMoves.includes(activeCircuit.items[j].id)){
                selectedMoveObjects.push(activeCircuit.items[j])
                selectedIndexes.push(j)
            }
        }

        // learn the lowest index
        const lowestIndex = arrayMin(selectedIndexes)

        // construct the round data structure
        const newItem = {
            confirmed: true,
            id: uuidv4(),
            type: 'round',
            items: selectedMoveObjects
        }

        // start popping the array
        const finalItems = []
        for (let i=0;i<state.circuits[circuitIndex].items.length;i++){
            const currentItem = state.circuits[circuitIndex].items[i]
            if (selectedMoves.includes(currentItem.id)){
                if (i === lowestIndex) {
                    finalItems.push(newItem)
                }
            }
            else{
                finalItems.push(currentItem)
            }
        }

        // assign new items
        state.circuits[circuitIndex].items = finalItems
        state.circuits =  JSON.parse(JSON.stringify(state.circuits))
    },
    ungroupRound(state, round) {
        let circuitIndex
        // discover which circuit to push new items
        for(let i=0;i<state.circuits.length;i++) {
            const circuit = state.circuits[i]
            for (let j=0;j<circuit.items.length;j++){
                if (circuit.items[j].id === round){
                    circuitIndex = i
                    break
                }
            }
        }
        // learn the indexes of the round to ungroup
        let selectedRoundIndex = 0
        const activeCircuit = state.circuits[circuitIndex]
        for (let j=0;j<activeCircuit.items.length;j++){
            if (activeCircuit.items[j].id === round){
                selectedRoundIndex = j
                break
            }
        }

        // start ungrouping by placing original items on round
        const newItems = []
        for (let j=0;j<activeCircuit.items.length;j++){
            if (j === selectedRoundIndex && activeCircuit.items[j].id === round) {
                for (let k=0;k<activeCircuit.items[j].items.length;k++){
                    const poppedItem = activeCircuit.items[j].items[k]
                    poppedItem.parent = null
                    newItems.push(poppedItem)
                }
            }
            else {
                newItems.push(activeCircuit.items[j])
            }
        }
        // assign new items
        state.circuits[circuitIndex].items = newItems
        state.circuits =  JSON.parse(JSON.stringify(state.circuits))
    },
    updateItemOrdering(state){
        let order = 1
        // figure out item ordering
        for (let i=0;i<state.circuits.length;i++) {
            const currentCircuit = state.circuits[i]
            for (let j=0;j<currentCircuit.items.length;j++) {
                const currentItem = currentCircuit.items[j]
                if (!state.circuits[i].items[j]) {
                    continue
                }
                state.circuits[i].items[j].order = order
                order += 1
                if (currentItem.type === 'round') {
                    for (let k=0;k<currentItem.items.length;k++) {
                        state.circuits[i].items[j].items[k].order = order
                        order += 1
                    }
                }
            }
        }
    },

    pushSelectedCircuit(state,circuitId) {
        state.selectedCircuits.push(circuitId)
    },

    popSelectedCircuit(state, circuitId) {
        state.selectedCircuits = state.selectedCircuits.filter(selectedCircuit => selectedCircuit !== circuitId)
    },

    clearSelectedCircuits(state) {
        state.selectedCircuits = []
    },

    setAutoCue(state, autoCue) {
        state.autoCue = autoCue
    },
    setCueItems(state, cueItems) {
        state.cueItems = cueItems
    },
    setCueWithRestItems(state, cueWithRestItems) {
        state.cueWithRestItems = cueWithRestItems
    },
    setCueWithRestItemsWithCircuit(state, cueWithRestItemsWithCircuit){
        state.cueWithRestItemsWithCircuit = cueWithRestItemsWithCircuit
    },
    setRoundItems(state, { roundId, items }) {
        for (let i=0;i<state.circuits.length;i++) {
            const currentCircuit = state.circuits[i]
            for (let j=0;j<currentCircuit.items.length;j++) {
                const currentItem = currentCircuit.items[j]
                if (!state.circuits[i].items[j]) {
                    continue
                }
               if (state.circuits[i].items[j].id === roundId) {
                   state.circuits[i].items[j].items = items
               }
            }
        }
    },

    setRender(state, payload) {
        state.render = payload
    }
    
}